import type { IconSvgObject } from './types';

const TangentIcon: IconSvgObject = [
  ["path", { d: "M2 14.4932C6.69177 9.8014 11.7589 9.23839 13.2602 10.7398C14.7616 12.2411 14.1986 17.3082 9.50683 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 5.5L18.5 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "8", cy: "4", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["circle", { cx: "20", cy: "16", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default TangentIcon;
